interface IRealestateWithNewsItems<TNewsItem> {
    newsitems: { newsitem: TNewsItem | null }[];
}

// IT2 loads a consolidation (Mandant) together with its realestates.
// A news for several of these realestates is shown only once.
export const getUniqueNewsItems = <TNewsItem extends { id: string }>(
    realestates: IRealestateWithNewsItems<TNewsItem>[]
): TNewsItem[] => {
    const newsItemsById = new Map<string, TNewsItem>();

    realestates.forEach((realestate) => {
        realestate.newsitems.forEach(({ newsitem }) => {
            if (newsitem && !newsItemsById.has(newsitem.id)) {
                newsItemsById.set(newsitem.id, newsitem);
            }
        });
    });

    return Array.from(newsItemsById.values());
};
